import { render, staticRenderFns } from "./PaymentFailPage.vue?vue&type=template&id=5f8de47c&"
import script from "./PaymentFailPage.vue?vue&type=script&lang=js&"
export * from "./PaymentFailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports